import React, { useState } from 'react';
import { toast } from 'sonner';
import { Camera, Sparkles, Loader2, X } from 'lucide-react';
import { API, errText, fileUrl } from '../../api';
import FileDrop from '../FileDrop';

export default function AiPhotoVideo({ req, data, version, rendering, onChanged }) {
  const [photos, setPhotos] = useState(data.photos || []);
  const [busy, setBusy] = useState(false);
  const isPro = data.level === 'pro';
  const left = Math.max(0, 3 - (data.ai_used || 0));

  const save = async (next) => {
    setPhotos(next);
    try { await API.setLaunchPhotos(req.code, next); } catch (e) { toast.error('Could not save photos.'); }
  };
  const add = (res) => { if (photos.length >= 6) { toast.error('Up to 6 photos.'); return; } save([...photos, res.url]); };
  const remove = (u) => save(photos.filter((p) => p !== u));
  const make = async () => {
    setBusy(true);
    try { await API.launchAiVideo(req.code, version); toast.success('Producing your AI video.', { description: 'About 1–2 minutes per photo, then the three formats. You can leave this page.' }); onChanged(); }
    catch (e) { toast.error(errText(e, 'Could not start.')); }
    finally { setBusy(false); }
  };

  if (!isPro) {
    return (
      <div className="rounded-2xl border hairline border-dashed p-5" data-testid="ai-video-upsell">
        <p className="flex items-center gap-2 text-sm text-cream"><Camera size={15} className="text-gold" /> Want a video with <em>your</em> people in it?</p>
        <p className="text-xs text-cream/50 mt-1">Launch Pad Pro animates 4–6 photos of your owner, staff and customers into a realistic 30-second loop under your song. Ask Perry to upgrade your Launch Pad.</p>
      </div>
    );
  }
  return (
    <div className="rounded-2xl border border-gold/30 bg-gold/[0.03] p-5" data-testid="ai-video-panel">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <p className="flex items-center gap-2 text-sm text-cream"><Camera size={15} className="text-gold" /> AI photo video <span className="text-[10px] tracking-widest uppercase bg-gold text-ink rounded-full px-2 py-0.5 ml-1">Pro</span></p>
        <span className="text-xs text-cream/50" data-testid="ai-video-left">{left} {left === 1 ? 'render' : 'renders'} left</span>
      </div>
      <p className="text-xs text-cream/55 mt-1 leading-relaxed">Upload 2–6 real photos — owner at the front desk, staff with a customer, your storefront. Still photos with people facing the camera animate best. Each becomes a 5-second realistic clip; we loop them under the full song in all three sizes.</p>
      <div className="mt-4 grid grid-cols-3 sm:grid-cols-6 gap-2" data-testid="ai-photos">
        {photos.map((u) => (
          <div key={u} className="relative aspect-square rounded-xl overflow-hidden border hairline">
            <img src={fileUrl(u)} alt="" className="w-full h-full object-cover" />
            <button onClick={() => remove(u)} data-testid="ai-photo-remove" className="absolute top-1 right-1 bg-ink/80 rounded-full p-1 text-cream/70 hover:text-heart"><X size={12} /></button>
          </div>
        ))}
        {photos.length < 6 && (
          <FileDrop accept="image/*" multiple onUploaded={add} testId="ai-photo-upload" className="aspect-square">
            <span className="text-xs text-center">+ Add photo</span>
          </FileDrop>
        )}
      </div>
      <button onClick={make} disabled={busy || rendering || photos.length < 2 || !left} data-testid="ai-video-make-btn" className="mt-4 btn-gold rounded-full px-6 py-3 text-sm flex items-center gap-2 disabled:opacity-50">
        {busy || rendering ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />} {rendering ? 'Producing…' : photos.length < 2 ? 'Add at least 2 photos' : 'Make my AI video'}
      </button>
    </div>
  );
}
